import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlreadyAssignPopupData, ListAssignEntitlement } from '@app/core/features/charts-manager/my-charts/my-charts-list';
import { TouchService } from '@app/core/services/touch/touch.service';
import { environment } from '@env/index';

@Component({
  selector: 'app-already-assigned',
  templateUrl: './already-assigned.component.html',
  styleUrls: ['./already-assigned.component.scss']
})
export class AlreadyAssignedComponent implements OnInit {
  isSelectKeepSeparateOption = true;
  isPossibleToMergeCharts = false;
  maximumMergedCharts = environment.maximumMergedCharts;
  public allowMerge = true;
  public listChartAssign = '';
  public currentEntitlement = '';
  public chartsSameContinent = '';

  constructor(
    public dialogRef: MatDialogRef<AlreadyAssignedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlreadyAssignPopupData,
    // this service is in-use by template, please do not remove
    public touchService: TouchService
  ) { }

  ngOnInit() {
    this.checkPossibleToMergeCharts();
    this.data.listCurrentEntitlementName.forEach(element => {
      const checkDuplicateProduct = this.data.listAlreadyAssignEntitlementName.find(x => x.produceId === element.produceId);
      if (checkDuplicateProduct) {
        this.allowMerge = false;
      }
    });

    this.currentEntitlement = this.data.listCurrentEntitlementName.map(x => x.name).join(' + ');

    if (this.allowMerge) {
      const listChartSameContinent = this.findListChartSameContinent();

      this.chartsSameContinent = listChartSameContinent.length > 0 ? listChartSameContinent.map(x => x.name).join(' + ') : '';

      this.data.listAlreadyAssignEntitlementName =
        this.data.listAlreadyAssignEntitlementName.filter(row =>
            row.mergeGroup === this.data.listCurrentEntitlementName[0].mergeGroup);

      if (this.data.listAlreadyAssignEntitlementName.length > 0) {
        const listAssignName = this.data.listAlreadyAssignEntitlementName.map(x => x.name);
        this.listChartAssign = `${this.currentEntitlement} + ${listAssignName.join(' + ')}`;
      }
    }
  }

  private findListChartSameContinent(): ListAssignEntitlement[] {
    const listChartSameContinent: ListAssignEntitlement[] = [];
    this.data.listAlreadyAssignEntitlementName.filter(row => {
      const element = this.data.listCurrentEntitlementName.find(x => x.mergeGroup !== row.mergeGroup);
      if (element) {
        listChartSameContinent.push(row);
      }
    });

    return listChartSameContinent;
  }

  select() {
    this.isSelectKeepSeparateOption = !this.isSelectKeepSeparateOption;
  }

  ok() {
    this.dialogRef.close({
      isSelectKeepSeparateOption: this.isSelectKeepSeparateOption
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  private checkPossibleToMergeCharts() {
    this.data.listAlreadyAssignEntitlementName.length < this.maximumMergedCharts ?
     this.isPossibleToMergeCharts = true : this.isPossibleToMergeCharts = false;
  }
}
